import React from "react";

import css from "./divider.module.css";

export default function Divider() {
  return <div className={css.divider} />;
}
